import React from 'react';

const UserIcon: React.FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse
      cx="3.71429"
      cy="3.65714"
      rx="3.71429"
      ry="3.65714"
      transform="matrix(-1 0 0 1 13.7109 2)"
      stroke="#120242"
      strokeWidth="1.5"
    />
    <path
      d="M3.5 14.7805C3.5 13.9704 4.01138 13.2485 4.77566 12.9797V12.9797C8.15707 11.7906 11.8429 11.7906 15.2243 12.9797V12.9797C15.9886 13.2485 16.5 13.9704 16.5 14.7805V15.9511C16.5 17.0331 15.5428 17.8651 14.4713 17.7144L13.7608 17.6144C11.2659 17.2635 8.73413 17.2635 6.23922 17.6144L5.52869 17.7144C4.45716 17.8651 3.5 17.0331 3.5 15.9511V14.7805Z"
      stroke="#120242"
      strokeWidth="1.5"
    />
  </svg>
);

export default UserIcon;
